import { useContext, useState } from 'react';
import { useMutation } from '@apollo/client';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import PropTypes from 'prop-types';

import { UNSHARE_PROJECT } from '../../apis/project';
import ProjectContext from '../../context/ProjectContext';
import Button from '../atoms/button';

const propTypes = {
  projectName: PropTypes.string,
};

const unshareProjectButton = (props) => {
  const { projectId, dispatch, usersOfProjects } = useContext(ProjectContext);
  const closeButton = 'Remove';
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [unshareProject] = useMutation(UNSHARE_PROJECT);
  const deleteButton = async () => {
    setOpen(true);
  };

  const handleClickOpen = async () => {
    setIsLoading(true);
    const variables = {
      input: {
        id: parseInt(props.data.id, 10),
        projectId: parseInt(projectId, 10),
      },
    };
    await unshareProject({
      variables,
    });
    const deletedRow = props.node.data;
    props.api.applyTransaction({ remove: [deletedRow] });
    const sharedUserProjects = usersOfProjects.filter(
      (userProjectData) => userProjectData.id !== deletedRow.id,
    );
    await dispatch({
      type: 'SET_USERS_PROJECTS_DETAIL',
      payload: {
        usersOfProjects: sharedUserProjects,
      },
    });
    setIsLoading(false);
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const cellValue = props.valueFormatted ? props.valueFormatted : props.value;

  return (
    <span>
      <span>{cellValue}</span>
      <Button small danger outlined onClick={deleteButton}>
        {closeButton}
      </Button>
      <Dialog
        className="custom-modal-dialog confirmation-modal-dialog"
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent className="dialog-content">
          <DialogContentText id="alert-dialog-description">
            {`Are you sure you want to remove ${props.data.userName}?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-actions">
          <Button disabled={isLoading} primary outlined onClick={handleClose}>Cancel</Button>
          <Button isLoading={isLoading} disabled={isLoading} danger onClick={handleClickOpen} autoFocus>Remove</Button>
        </DialogActions>
      </Dialog>
    </span>
  );
};
unshareProjectButton.propTypes = propTypes;
export default unshareProjectButton;
